import { isObjectDeeplyChanged } from '../../util/state';
import { State } from './selector';

/**
 * Update flags for App container
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const { isLoading, error, tariffs, selectedTariffId, isLoggedIn } = state;
    const tariffsChanged = isObjectDeeplyChanged(tariffs, oldState.tariffs);
    const selectedChanged = selectedTariffId !== oldState.selectedTariffId;

    return {
        loading: isLoading !== oldState.isLoading,
        error: error !== oldState.error,
        loginStatus: isLoggedIn !== oldState.isLoggedIn || tariffsChanged,
        tariffsChanged: tariffsChanged || selectedChanged,
    };
};
